const publicHomepageContent = {
  headline: 'Grip op het maaibeheer',
  intro: 'De applicatie brengt robots, locaties, meldingen en onderhoud samen. Zo hebben beheerders en technici één actueel overzicht voor het dagelijkse werk.',
  infoPoints: [
    { key: 'overview', title: 'Overzicht', text: 'Robots, locaties en meldingen samen in één beheeromgeving.' },
    { key: 'maintenance', title: 'Onderhoud', text: 'Werkzaamheden, bijzonderheden en gebruikte onderdelen overzichtelijk vastgelegd.' },
    { key: 'insight', title: 'Inzicht', text: 'Actuele informatie voor planning, service en verdere verbetering van het maaibeheer.' },
  ],
  statsSection: {
      title: 'Robotbeheer in cijfers',
      subtitle: 'Een compact overzicht van het actuele robotpark en de locaties.'
  },
  modelsSection: {
    title: 'Robotmaaiers in beheer',
    intro: 'Wij werken met robotmaaiers van Belrobotics, Husqvarna en Kress.',
    // Brands are listed if logo assets are available; counts omitted unless reliable
    brands: [
      { key: 'belrobotics', name: 'Belrobotics', logo: '/belrobotics-logo.png' },
      { key: 'bel-bm850', name: 'BM 850 — RTK', logo: null },
      { key: 'bel-bm1050', name: 'BM 1050 — RTK', logo: null },
      { key: 'bel-bm2050', name: 'BM 2050 — RTK', logo: null },
      { key: 'bel-pm1000-rtk', name: 'PM 1000 — RTK', logo: null },
      { key: 'bel-pm1000-wire', name: 'PM 1000 — draadgestuurd', logo: null },
      { key: 'husqvarna', name: 'Husqvarna', logo: '/Huqvarna-Logo.png' },
      { key: 'kress', name: 'Kress', logo: '/Kress-Logo.png' },
    ]
  },
  serviceSection: {
    title: 'Beheer en service in de praktijk',
    steps: [
      { key: 'signal', title: 'Signaleren', text: 'Een onderhoudspunt of bijzonderheid wordt herkend.' },
      { key: 'registreren', title: 'Registreren', text: 'Robot- en locatiegegevens worden vastgelegd.' },
      { key: 'uitvoeren', title: 'Uitvoeren', text: 'Werkzaamheden en gebruikte onderdelen worden geregistreerd.' },
      { key: 'feedback', title: 'Terugkoppelen', text: 'De informatie blijft beschikbaar voor beheer en rapportage.' },
    ]
  },
  contactBanner: {
    titleLines: ['Direct aan de slag'],
    subtext: "Eén omgeving voor robots, meldingen, onderhoud en locaties.",
    cta: { label: 'Contact', href: 'https://krinkels.nl/contact/' }
  }
};

export default publicHomepageContent;
